import React, { useState } from 'react';
import ChatWindow from './ChatWindow'; // Import the ChatWindow component

const ChatPage = () => {
  const [messages, setMessages] = useState([]);
  const [chatInput, setChatInput] = useState('');

  const handleSendMessage = (e) => {
    e.preventDefault();
    const newMessage = { sender: 'user', text: chatInput };
    setMessages([...messages, newMessage]);
    setChatInput('');
    // Handle sending the message to backend or WebSocket here
  };

  return (
    <div>
      <ChatWindow
        messages={messages}
        chatInput={chatInput}
        setChatInput={setChatInput}
        handleSendMessage={handleSendMessage}
      />
    </div>
  );
};

export default ChatPage;